import { useCallback, useState } from "react";
import ContractsService from "../../../services/accounts/contracts";

export const useFetchAccountNumber = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const findByNumber = useCallback(async (number: number) => {
    try {
      setIsLoading(true);
      const res = await ContractsService.searchByNumber(number);
      setIsLoading(false);
      return res;
    } catch (e: any) {
      setIsLoading(false);
      return null;
    }
  }, []);

  return { isLoading, findByNumber };
};
